/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CustomOptions/view.blocks to change it.
import * as fromData from 'Simple/Data'
import Paypoint from './Paypoint/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function CustomOptions({
  children,
  viewPath = "/App/Account/Content/Settings/Content/PaymentProviders/AddAction/Content/Content/Payabli/Paypoints/CustomOptions",
  onClick
  
}) {
let addProviderPayabliPaypointsValueData = fromData.useDataValue({ viewPath,
context: 'add_provider',
path: 'payabli.paypoints',
})
  return (<React.Fragment
>
<div
  data-testid="CustomOptions.List"
  data-view-path={viewPath}
 className="views-block"
>
{Array.isArray(addProviderPayabliPaypointsValueData) && addProviderPayabliPaypointsValueData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="add_provider_payabli_paypoint"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/Paypoint(${item?.id ?? item?._id ?? index})`}
      >
<Paypoint
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/Paypoint(${item?.id ?? item?._id ?? index})`}
 onPaypointClick={onClick}
/>
</ListItem>
)}
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }